import * as ActionTypes from '../../../constants/actionTypes';

const setAlertCounts = (payload) => ({
  type: ActionTypes.APP_ALERT_LANDING_COUNTS,
  payload,
});
const setAlerts = (payload) => ({
  type: ActionTypes.APP_ALERT_ALERTS_SET,
  payload,
});
const setAlertsCustom = (payload) => ({
  type: ActionTypes.APP_ALERT_CUSTOM_SET,
  payload,
});
const resetReducers = () => ({
  type: ActionTypes.REDUX_RESET,
});
const setSelectedTeamName = (payload) => ({
  type: ActionTypes.APP_ALERT_TEAMNAME_SET,
  payload,
});
const setSelectedDateRange = (payload) => ({
  type: ActionTypes.APP_ALERT_DATERANGE_SET,
  payload,
});
const setSelectedDateRangePicker = (payload) => ({
  type: ActionTypes.APP_ALERT_DATERANGEPICKER_SET,
  payload,
});
const setSelectedAlertType = (payload) => ({
  type: ActionTypes.ALERT_TYPE,
  payload,
});
export {
  setAlertCounts,
  resetReducers,
  setSelectedTeamName,
  setSelectedDateRange,
  setSelectedDateRangePicker,
  setAlerts,
  setAlertsCustom,
  setSelectedAlertType
};
